module.exports = __webpack_public_path__ + "img/3.b8cf5ef6.png";